module.exports = __webpack_public_path__ + "img/schiffchen-2.6066ee63.jpg";